import Settings from 'Settings'

import {imageProviderImgProxyFactory} from '@daedalus/core/src/staticContent/services/imageProviderFactories'

export const imageProvider = imageProviderImgProxyFactory({
  secret: Settings.get('REACT_APP_IMGPROXY_ENDPOINT_SECRET'),
  url: Settings.get('REACT_APP_IMGPROXY_ENDPOINT_URL')
})
